<template>
  <!--日期选择组件 -->
  <el-dialog :title="title" style="color:white" :visible.sync="dialogFormVisible" append-to-body
    custom-class="mainDialog" @close="handleClose">
    <div class="pbodyinfo">
      <div class="block" style="text-align: center;">
        <el-date-picker v-model="value5" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" v-if="$route.path === '/remoteSenseData'">
        </el-date-picker>
        <el-date-picker v-model="value6" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" v-else>
        </el-date-picker>
      </div>
    </div>
    <div class="bodyinfo flexleft" v-if="$route.path !== '/remoteSenseData'">
      <el-checkbox v-model="ischeckbox" class="mleft">开启时刻查询</el-checkbox>
    </div>
    <div v-if="ischeckbox">
      <div class="bodyinfo flexleft">
        <div class="mleft">选择时刻 ：时刻 ：<select v-model="valuehours" class="zdydl" placeholder="请选择">
            <option v-for="item in optionhours" :key="item" :label="item" :value="item">{{item}}
            </option>
          </select> 分钟：<select v-model="valuemin" placeholder="请选择">
            <option v-for="item in optionsmin" :key="item" :label="item" :value="item">{{item}}
            </option>
          </select>
          <el-button type="success" size="mini" class="cshi" @click="addshhike">添加</el-button>
        </div>

      </div>
      <div class="bodyinfo flexboder">
        <el-tag :key="tag" class="idtag" style="width:auto" v-for="tag in dynamicTags" closable
          :disable-transitions="false" @close="handleClose(tag)">
          {{tag}}
        </el-tag>
      </div>
    </div>
    <div class="bodyinfo flexleft" v-if="$route.path !== '/remoteSenseProduct'">
      <div>
        <el-col style="margin-bottom: 10px;">空间分辨率(m)</el-col>
        <el-row style="margin-bottom: 10px;">
          <el-col :span="7">
            <el-input type="number" v-model="spatial_resolution_min" step="0.1" style="width: 37%;" max='100000'
              min="0"></el-input>
            -
            <el-input type="number" v-model="spatial_resolution_max" step="0.1" style="width: 37%;" max='100000'
              min="0">
            </el-input>m
          </el-col>
          <el-col style="width: 59.66667%;">
            <el-slider v-model="spatial_resolution_min" :step="0.1" :max="100000"></el-slider>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-col style="margin-bottom: 10px;">入射角(°)</el-col>
        <el-row style="margin-bottom: 10px;">
          <el-col :span="7">
            <el-input type="number" step="0.1" v-model="sun_elevation_min" style="width: 37%;" max='90' min="0">
            </el-input>
            -
            <el-input type="number" step="0.1" v-model="sun_elevation_max" style="width: 37%;" max='90' min="0">
            </el-input>°
          </el-col>
          <el-col style="width: 59.66667%;">
            <el-slider v-model="sun_elevation_min" :step="0.1" :max="90"></el-slider>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-col style="margin-bottom: 10px;">云层覆盖(%)</el-col>
        <el-row style="margin-bottom: 10px;">
          <el-col :span="7">
            <el-input type="number" step="0.1" v-model="cloud_percent_min" style="width: 37%;" max='100' min="0">
            </el-input>
            -
            <el-input type="number" step="0.1" v-model="cloud_percent_max" style="width: 37%;" max='100' min="0">
            </el-input>%
          </el-col>
          <el-col style="width: 59.66667%;">
            <el-slider v-model="cloud_percent_min" :step="0.1" :max="100"></el-slider>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-col style="margin-bottom: 10px;">哨兵2景号</el-col>
        <el-row style="margin-bottom: 10px;">
          <el-col :span="7">
            <el-input type="text" v-model="scene_no" style="width: 80%;">
            </el-input>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="margin-top: 20px;text-align: center;" v-if="$route.path === '/subscriptionData'">
      <el-button class="buttongteys" @click="preStep">上一步</el-button>
      <el-button style="margin-left: 60px;" class="buttongtey" type="primary" @click="saveday">下一步</el-button>
    </div>
    <div style="margin-top: 20px;text-align: center;" v-else>
      <el-button class="buttongtey" type="primary" @click="saveday">确 定</el-button>
      <el-button style="margin-left: 60px;" class="buttongteys" @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '../../vuex/index.js'
export default {
  name: 'HeadDayDialog',
  props: ['msgFather', 'prodata', 'rdate', 'pdate'],
  data () {
    return {
      dialogFormVisible: false,
      value5: [],
      value6: [],
      ischeckbox: false,
      optionsmin: [0, 15, 30, 45],
      optionhours: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
      ],
      valuemin: 0,
      valuehours: 0,
      dynamicTags: [],
      spatial_resolution_min: 0,
      spatial_resolution_max: 100000,
      sun_elevation_min: 0,
      sun_elevation_max: 90,
      cloud_percent_min: 0,
      cloud_percent_max: 100,
      scene_no: null
    }
  },
  created () {
    let d = new Date()
    // 设定结束日期为当前日期
    this.value5.push(d)
    this.value6.push(d)
    // 当前设定的日期时间为当前月的第一天
    let year1, month1
    [year1, month1] = [d.getFullYear(), d.getMonth()]
    let date1 = new Date(year1, month1, 1)
    this.value5.unshift(date1)
    this.value6.unshift(date1)
  },
  computed: {
    title () {
      let name = ''
      if (this.$route.path === '/remoteSenseData') {
        name = '筛选条件'
      } else if (this.$route.path === '/subscriptionData') {
        name = '时间范围'
      } else {
        name = '日期选择'
      }
      return name
    }
  },
  methods: {
    format: function (fmt, data) {
      var o = {
        'M+': data.getMonth() + 1,
        'd+': data.getDate(),
        'h+': data.getHours(),
        'm+': data.getMinutes(),
        's+': data.getSeconds(),
        'q+': Math.floor((data.getMonth() + 3) / 3),
        S: data.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
          )
        }
      }
      return fmt
    },
    // 上一步
    preStep () {
      this.dialogFormVisible = false
      this.$emit('showClassDialog')
    },
    // 保存用户选取时间范围
    saveday: function () {
      store.commit('setLoading', true)
      var dayarr = []
      if (this.$route.path === '/remoteSenseData') {
        dayarr.push(this.format('yyyy-MM-dd', this.value5[0]) + ' 00:00:00')
        dayarr.push(this.format('yyyy-MM-dd', this.value5[1]) + ' 23:59:59')
        // dayarr.push(this.value5[0] + ' 00:00:00')
        // dayarr.push(this.value5[1] + ' 23:59:59')
      } else {
        dayarr.push(this.format('yyyy-MM-dd', this.value6[0]) + ' 00:00:00')
        dayarr.push(this.format('yyyy-MM-dd', this.value6[1]) + ' 23:59:59')
        // dayarr.push(this.value6[0] + ' 00:00:00')
        // dayarr.push(this.value6[1] + ' 23:59:59')
      }

      var datajson = {
        data: dayarr,
        hours: this.dynamicTags
      }
      var remoteSenseFormData = {
        spatial_resolution_min: this.spatial_resolution_min,
        spatial_resolution_max: this.spatial_resolution_max,
        sun_elevation_min: this.sun_elevation_min,
        sun_elevation_max: this.sun_elevation_max,
        cloud_percent_min: this.cloud_percent_min,
        cloud_percent_max: this.cloud_percent_max,
        scene_no: this.scene_no
      }
      datajson['remoteSenseFormData'] = remoteSenseFormData
      this.dialogFormVisible = false
      this.$emit('getdaydialogFormDate', datajson)
    },
    sendMsgToParent: function () {
      this.$emit('getdaydialogFormVisible', this.dialogFormVisible)
    },
    handleClose: function (tag) {
      let _this = this
      this.dynamicTags.forEach(function (item, index) {
        if (item === tag) {
          _this.dynamicTags.splice(index, 1)
        }
      })
      // _this.spatial_resolution_min = 0
      // _this.spatial_resolution_max = 40
      // _this.sun_elevation_min = 0
      // _this.sun_elevation_max = 90
      // _this.cloud_percent_min = 0
      // _this.cloud_percent_max = 100
    },
    addshhike: function () {
      var value = this.valuehours + ':' + this.valuemin
      if (this.dynamicTags.indexOf(value) === -1) {
        this.dynamicTags.push(value)
      }
    }
  },
  // 监听当前时间组件
  watch: {
    msgFather: function (curVal) {
      this.dialogFormVisible = curVal
    },
    dialogFormVisible () {
      this.sendMsgToParent()
    },
    rdate (value) {
      if (value.length > 0) {
        this.value5 = value
      }
    },
    pdate (value) {
      if (value.length > 0) {
        this.value6 = value
      }
    }
  }
}
</script>
<style scoped>
.idtag {
  border-radius: 2px;
}
.el-button--success {
  margin-left: 15px;
  color: #fff;
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.cshi {
  width: 50px;
  padding: 7px 7px;
}
.mleft {
  margin-left: 5px;
}
.flexboder .el-tag .el-icon-close i {
  margin-top: 8px;
}
.flexboder {
  border: 1px #ccc solid;
  width: 79%;
  margin-left: 10%;
  display: flex;
  justify-content: flex-start;
  padding-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  border-radius: 5px;
  flex-wrap: wrap;
}
select {
  background: transparent;
  outline: none;
}
textarea {
  outline: none;
}
.flexleft {
  text-align: left;
  padding-left: 10%;
}
.pbodyinfo {
  margin-top: 35px;
}
.bodyinfo {
  margin-top: 15px;
}
.el-range-editor.el-input__inner {
  display: -webkit-inline-box;
  width: 80%;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3px 10px;
}
.el-dialog__header {
  background: #1d202f;
  border-radius: 8px 8px 0 0;
  height: 1.25rem;
}
.dialog__header span {
  color: white;
}
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadDayDialog.vue